import React from 'react';

import { NwButton, NwRemoveButton } from '@components/Gui/NwButton';

import {
    getArticleRowLayoutCssGridTemplate,
    normalizeArticleRowLayoutKey,
} from '@containers/Art/Articles/Articles.constants';

import ArticleEditorColumn from './ArticleEditorColumn';
import {
    ArticleColumnsGrid,
    ArticleRowActions,
    ArticleRowBody,
    ArticleRowEditor,
    ArticleRowHeader,
    ArticleRowTitle,
    ArticleRowTitleGroup,
} from './ArticleEditorRow.styles';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ArticleEditorRow = ({
    columnsSorted,
    row,
    rowIndex,
    sortByPositionFn,
    sortedRowsLength,
    onAddBlock,
    onApplyEmbedMedia,
    onChangeBlockText,
    onChangeBlockTitle,
    onChangeEmbedInput,
    onChangeLinkText,
    onChangeMediaSource,
    onChangeNetwalkModel,
    onConfigureRowLayout,
    onMoveRow,
    onOpenMediaSelector,
    onRemoveBlock,
    onRemoveRow,
    onSelectUploadedMedia,
    onUploadFileEnd,
    onUploadMediaEnd,
    uploadedSelectorZIndex,
}) => {
    const showRowReorderArrows = sortedRowsLength > 1;
    const layoutKey = normalizeArticleRowLayoutKey(row.Layout);

    return (
        <ArticleRowEditor>
            <ArticleRowHeader>
                <ArticleRowTitleGroup>
                    <ArticleRowTitle>Row {rowIndex + 1}</ArticleRowTitle>
                    <NwButton
                        ghost
                        icon={byPrefixAndName.fasl['pen']}
                        iconOnly
                        tooltip="Change row layout"
                        onClick={() => onConfigureRowLayout(row.ID)}
                    />
                </ArticleRowTitleGroup>
                <ArticleRowActions>
                    {showRowReorderArrows ? (
                        <>
                            <NwButton
                                disabled={rowIndex === 0}
                                ghost
                                icon={byPrefixAndName.fasl['arrow-up']}
                                iconOnly
                                onClick={() => onMoveRow(rowIndex, rowIndex - 1)}
                            />
                            <NwButton
                                disabled={rowIndex === sortedRowsLength - 1}
                                ghost
                                icon={byPrefixAndName.fasl['arrow-down']}
                                iconOnly
                                onClick={() => onMoveRow(rowIndex, rowIndex + 1)}
                            />
                        </>
                    ) : null}
                    <NwRemoveButton
                        danger
                        ghost
                        icon={byPrefixAndName.fass['circle-xmark']}
                        iconOnly
                        needConfirmation={false}
                        tooltip="Remove row"
                        onClick={() => onRemoveRow(row.ID)}
                    />
                </ArticleRowActions>
            </ArticleRowHeader>
            <ArticleRowBody>
                <ArticleColumnsGrid
                    style={{
                        '--article-row-grid-template': getArticleRowLayoutCssGridTemplate(layoutKey),
                    }}
                >
                    {columnsSorted.map((column) => (
                        <ArticleEditorColumn
                            key={column.ID}
                            column={column}
                            row={row}
                            sortByPositionFn={sortByPositionFn}
                            onAddBlock={onAddBlock}
                            onApplyEmbedMedia={onApplyEmbedMedia}
                            onChangeBlockText={onChangeBlockText}
                            onChangeBlockTitle={onChangeBlockTitle}
                            onChangeEmbedInput={onChangeEmbedInput}
                            onChangeLinkText={onChangeLinkText}
                            onChangeMediaSource={onChangeMediaSource}
                            onChangeNetwalkModel={onChangeNetwalkModel}
                            onOpenMediaSelector={onOpenMediaSelector}
                            onRemoveBlock={onRemoveBlock}
                            onSelectUploadedMedia={onSelectUploadedMedia}
                            onUploadFileEnd={onUploadFileEnd}
                            onUploadMediaEnd={onUploadMediaEnd}
                            uploadedSelectorZIndex={uploadedSelectorZIndex}
                        />
                    ))}
                </ArticleColumnsGrid>
            </ArticleRowBody>
        </ArticleRowEditor>
    );
};

export default ArticleEditorRow;
